import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "@apollo/client";
import apolloClient from "./graphql/client";

import App from "./App";
import "./index.css";
// Design tokens FIRST (--color-*, spacing…), then the brand kit that
// builds on them. variables.css was previously imported nowhere, so
// every rule referencing var(--color-primary) silently resolved to
// nothing — which is how the login/signup buttons went invisible when
// adminlogin.css switched its hardcoded blues to the tokens.
import "./styles/variables.css";
import "./styles/brand.css";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <App />
  </ApolloProvider>,
  rootElement
);
